import clsx from "clsx";
import { DateFormat } from "common";
import dayjs from "dayjs";
import { startCase } from "lodash";
import React from "react";
import { useUser } from "../../hooks/useAccount";
import { isXolaAdmin } from "../../models/User";
import { SupportItem } from "./SupportItem";

export const ReleaseVersion = () => {
    const user = useUser();

    const releaseDate = process.env.RELEASE_DATE
        ? dayjs(process.env.RELEASE_DATE, "X").format(DateFormat.DEBUG)
        : "N/A";

    return (
        <div>
            <SupportItem
                name="App Version"
                copyText={process.env.VERSION_HASH}
                value={
                    <span className="font-mono" data-branch={process.env.BUILD_BRANCH} data-release-date={releaseDate}>
                        <var data-var="releaseHash">{process.env.VERSION_HASH}</var>
                        <span className={clsx("pl-1", isXolaAdmin(user) ? "text-gray-darker" : "text-white")}>
                            Release Date: <var data-var="releaseDate">{releaseDate}</var>
                        </span>
                    </span>
                }
            />
            {process.env.ENVIRONMENT !== "production" && (
                <SupportItem
                    name="Environment"
                    copyText={process.env.ENVIRONMENT}
                    value={startCase(process.env.ENVIRONMENT)}
                />
            )}
        </div>
    );
};
